import React from "react";
import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

const Shield = ({ color = "black", className }: IconProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99967 14C7.99967 14 12.6663 12 12.6663 9.33333V7.33333M7.99967 14C7.99967 14 3.33301 12 3.33301 9.33333V7.33333M7.99967 14V7.33333M7.99967 2C9.33301 3.33333 11.6663 3.44444 12.6663 3.33333V7.33333M7.99967 2C6.66634 3.33333 4.33301 3.44444 3.33301 3.33333V7.33333M7.99967 2V7.33333M7.99967 7.33333H12.6663M7.99967 7.33333H3.33301"
        stroke={COLORS[color]}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Shield;
